import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

export const getChequeReceiptListApi = (
  requestPayload,
  businessAreaId,
  ...rest
) => {
  const [depositId, cashierOffice, statusFilters] = rest;
  const { pageNo, pageSize } = requestPayload;
  const request = {
    ...requestPayload,
    businessArea: businessAreaId,
    cashierOffice,
    paymentType: "CHKL",
  };
  if (
    statusFilters &&
    statusFilters?.statusFilters?.length > 0 &&
    !request.status?.length > 0
  ) {
    request.status = statusFilters?.statusFilters || [];
  }
  if (depositId) {
    request.referenceNumber = depositId;
    request.status = [];
  }
  const url = `${endpoint.cashManagement.chequeDashboard.receiptList}?offset=${pageNo}&pageSize=${pageSize}`;

  return fetchAllPostPromisedData(url, request, "POST");
};

export const getAllChequeReceiptListApi = (
  requestPayload,
  businessAreaId,
  ...rest
) => {
  const [depositId, cashierOffice, statusFilters] = rest;
  const { pageNo, pageSize } = requestPayload;
  const request = {
    ...requestPayload,
    businessArea: businessAreaId,
    cashierOffice,
    paymentType: "CHKL",
    isFutureCheque: true,
  };
  if (
    statusFilters &&
    statusFilters?.statusFilters?.length > 0 &&
    !request.status?.length > 0
  ) {
    request.status = statusFilters?.statusFilters || [];
  }
  if (depositId) {
    request.referenceNumber = depositId;
    request.status = [];
  }
  const url = `${endpoint.cashManagement.chequeDashboard.receiptList}?offset=${pageNo}&pageSize=${pageSize}`;

  return fetchAllPostPromisedData(url, request, "POST");
};

export const getListByChequeNumberApi = (payload) => {
  const url = `${
    endpoint.cashManagement.chequeDashboard.receiptList
  }?offset=${0}&pageSize=${100}`;

  return fetchAllPostPromisedData(url, payload, "POST");
};
